require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./es-mx-update-consultas-sobre-el-marco-de-politicas-ambientales-y.json") })
        }
      }, "path---es-mx-update-consultas-sobre-el-marco-de-politicas-ambientales-y");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---es-mx-update-consultas-sobre-el-marco-de-politicas-ambientales-y!./.cache/json/es-mx-update-consultas-sobre-el-marco-de-politicas-ambientales-y.json
// module id = 925
// module chunks = 231608221292675